import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=7bfb9371&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"
import style0 from "./Brand.vue?vue&type=style&index=0&id=7bfb9371&prod&lang=scss&scoped=true"
import style1 from "./Brand.vue?vue&type=style&index=1&id=7bfb9371&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb9371",
  null
  
)

export default component.exports